import { render } from "./MyInfo.vue?vue&type=template&id=0004f872"
import script from "./MyInfo.vue?vue&type=script&lang=js"
export * from "./MyInfo.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./MyInfo.vue?vue&type=style&index=0&id=0004f872&module=true&lang=css"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__